<itl-loading-indicator *ngIf="!patient || !currentUser"></itl-loading-indicator>
<div *ngIf="patient && currentUser" class="articles">
  <swodoc-node-crossTherapy-article-list-item
    *ngFor="let crossTherapyArticleLine of node.responses[0].value"
    [articleLine]="crossTherapyArticleLine"
    [patient]="patient"
    [user]="currentUser"
    [node]="node"
    [showIdentificationNumbers]="showIdentificationNumbers"
    [showStorageLocation]="node.options?.showStorageLocation ? true : false"
    [showScanButtons]="showScanButtons"
  ></swodoc-node-crossTherapy-article-list-item>
  <div class="button">
    <itl-button (click)="addArticle()">{{ 'crossTherapy.document.addArticle' | translate }}</itl-button>
  </div>
</div>
